import axios from 'axios';
import config from '@/config';

const HTTP = axios.create({
  baseURL: config.API.ENDPOINT,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

export default HTTP;
